import { useEffect } from "react";

const DEFAULT_TITLE = "Wünberg | Premium Akrilik Hobi Boyaları";
const DEFAULT_DESC =
  "Wünberg Paint & Coating — sanatçılar için yüksek pigment yoğunluklu, UV dayanımlı premium akrilik hobi boyaları. Bayilik fırsatları ve renk paletleri.";
const SITE_NAME = "Wünberg Paint & Coating";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({
  title,
  description,
  image,
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Wünberg` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    document.title = fullTitle;

    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", type, "property");
    setMeta("og:site_name", SITE_NAME, "property");
    if (image) setMeta("og:image", image, "property");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    if (image) setMeta("twitter:image", image);

    setLink("canonical", window.location.href);

    // JSON-LD structured data
    let jsonLdEl = document.getElementById("wb-jsonld");
    if (jsonLd) {
      if (!jsonLdEl) {
        jsonLdEl = document.createElement("script");
        jsonLdEl.id = "wb-jsonld";
        jsonLdEl.type = "application/ld+json";
        document.head.appendChild(jsonLdEl);
      }
      jsonLdEl.textContent = JSON.stringify(jsonLd);
    } else if (jsonLdEl) {
      jsonLdEl.remove();
    }
  }, [title, description, image, type, jsonLd]);

  return null;
}
